import ApiClient from 'api-client/ApiClient'
import store from 'app/store'
import ActionsSet from 'core/actions/ActionsSet'
import CreateAction from 'core/actions/CreateAction'
import DeleteAction from 'core/actions/DeleteAction'
import ListAction from 'core/actions/ListAction'
import UpdateAction from 'core/actions/UpdateAction'
import { cacheActions } from 'core/caching/cacheReducers'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'
import { pathStr } from 'utils/fp'
import { trackEvent } from 'utils/tracking'

const { kubernetes } = ApiClient.getInstance()

export const kaapiClusterAddonsActions = ActionsSet.make<DataKeys.KaapiClusterAddons>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiClusterAddons],
  cacheKey: DataKeys.KaapiClusterAddons,
})

export const listKaapiClusterAddons = kaapiClusterAddonsActions.add(
  new ListAction<DataKeys.KaapiClusterAddons, { namespace: string }>(async ({ namespace }) => {
    Bugsnag.leaveBreadcrumb('Attempting to list Kaapi KaapiClusterAddons', { namespace })
    return kubernetes.getAllCustomResources(DataKeys.KaapiClusterAddons)
  }),
)

export const createKaapiClusterAddon = kaapiClusterAddonsActions.add(
  new CreateAction<DataKeys.KaapiClusterAddons, { namespace: string; body: any }>(
    async ({ namespace, body }) => {
      Bugsnag.leaveBreadcrumb('Attempting to create Kaapi ClusterAddon', {
        namespace,
        body,
      })
      const created = await kubernetes.createCustomResource({
        type: DataKeys.KaapiClusterAddons,
        body,
      })
      trackEvent('Create New Kaapi ClusterAddon', {
        namespace,
        name: pathStr('metadata.name', created),
      })
      return created
    },
  ),
)

export const deleteKaapiClusterAddon = kaapiClusterAddonsActions.add(
  new DeleteAction<DataKeys.KaapiClusterAddons, { namespace: string; name: string }>(
    async ({ namespace, name }) => {
      Bugsnag.leaveBreadcrumb('Attempting to delete Kaapi ClusterAddon', {
        namespace,
        name,
      })
      return await kubernetes.deleteCustomResource({
        type: DataKeys.KaapiClusterAddons,
        name,
      })
    },
  ),
)

export const updateKaapiClusterAddon = kaapiClusterAddonsActions.add(
  new UpdateAction<
    DataKeys.KaapiClusterAddons,
    { namespace: string; customBody: any; name: string }
  >(async ({ namespace, customBody, name }) => {
    Bugsnag.leaveBreadcrumb('Attempting to update Kaapi ClusterAddon', {
      namespace,
      customBody,
      name,
    })
    const response = await kubernetes.patchCustomResource({
      type: DataKeys.KaapiClusterAddons,
      name,
      body: customBody,
      contentType: 'application/merge-patch+json',
    })

    store.dispatch(
      cacheActions.updateItem({
        uniqueIdentifier: 'metadata.uid',
        cacheKey: DataKeys.KaapiClusterAddons,
        item: response,
        params: { metadata: { uid: response.metadata.uid } },
      }),
    )
    return response
  }),
)
